import { createElement, forwardRef } from 'react'

import { splitProps } from '../helpers.mjs';
import { getLevelCenterStyle } from '../patterns/level-center.mjs';
import { styled } from './factory.mjs';

export const LevelCenter = /* @__PURE__ */ forwardRef(function LevelCenter(props, ref) {
  const [patternProps, restProps] = splitProps(props, [])

const styleProps = getLevelCenterStyle(patternProps)
const mergedProps = { ref, ...styleProps, ...restProps }

return createElement(styled.div, mergedProps)
  })